const readMore = document.getElementById("show-more");
const readLess = document.getElementById("show-less");
const fullText = document.querySelector(".collection-description");
const box = document.querySelector(".collection-box");

readMore.addEventListener("click", () => {
	readMore.classList.add("hidden");
	readLess.classList.remove("hidden");
	fullText.classList.remove("line-clamp");
	fullText.classList.remove("reduced");
});

readLess.addEventListener("click", () => {
	fullText.classList.add("reduced");
	setTimeout(() => {
		readMore.classList.remove("hidden");
		readLess.classList.add("hidden");
		fullText.classList.add("line-clamp");
	}, 500);
});